import { Button, Col, Divider, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import styles from './welcome.page.module.scss';
import DOMPurify from 'dompurify';
import { Club } from '@hefe/models';

/* eslint-disable-next-line */
export interface WelcomePageProps {
  club?: Club;
}

export function WelcomePage(props: WelcomePageProps) {
  const params = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const club: any = props.club ?? params['club'];

  if (!club) {
    navigate('/');
    return null;
  }

  let cleanHTML;
  if (club.welcome_text) {
    cleanHTML = DOMPurify.sanitize(club.welcome_text, {
      USE_PROFILES: { html: true },
    });
  }

  return (
    <div className={styles['container']}>
      <Row>
        <Col span={24}>
          <Typography.Title style={{ marginTop: 20 }} level={2}>
            {t('marketing_texts.welcome_to_backcourt')}
          </Typography.Title>
          <Typography.Paragraph>
            {t('marketing_texts.description')}
          </Typography.Paragraph>
          <Button
            type="primary"
            onClick={() => {
              navigate('/login');
            }}
          >
            {t('login_now')}
          </Button>
          <h4 style={{ margin: 20 }}>{t('marketing_texts.download_app')}</h4>
          <a
            href="https://apps.apple.com/ch/app/backcourt/id1516234256"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="../../../../assets/images/appstore/AppStoreBadge.svg"
              height="40px"
              alt="App_Store_Badge"
            />
          </a>
          {'   '}
          <a
            href="https://play.google.com/store/apps/details?id=com.blum.hefe"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="../../../../assets/images/appstore/GooglePlayBadge.svg"
              height="40px"
              alt="Google_Play_Badge"
            />
          </a>
        </Col>
      </Row>
      <Divider />
      {cleanHTML && (
        <Row>
          <Col span={24}>
            <Typography.Title level={4}>
              {t('information_texts.club_information')}:
            </Typography.Title>
            <div style={{ margin: 20 }}>
              {club.logo && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    alt="Club Logo"
                    src={club.logo}
                    style={{ width: '150px' }}
                  />
                </div>
              )}
              <div dangerouslySetInnerHTML={{ __html: cleanHTML }} />
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
}

export default WelcomePage;
